<template>
  <tr
      class="mdm-insert-row"
      style="background-color: rgb(255, 253, 247);font-size: 12px"
  >
    <th
        class="mdm-form-cell mdm-form-cell-spacer action-col"
        :class="{ 'mdm-sticky-block-edge': fr.stickyBlockRightEdgeIsAction }"
        style="background-color: rgb(231, 255, 231);font-size: 12px"
    >
      <div
          class="mdm-action-toolbar mdm-action-toolbar-insert"
          role="toolbar"
          aria-label="New row actions"
          style="margin-left: 10px;"
      >
        <button
            type="button"
            class="mdm-toolbar-btn mdm-toolbar-btn-save"
            title="Save new record"
            aria-label="Save new record"
            :disabled="mdmVeeInvalid"
            @click="fr.validateInsertRow(rowEdit)"
        >
          <i class="fas fa-check" aria-hidden="true"></i>
        </button>
        <button
            type="button"
            class="mdm-toolbar-btn mdm-toolbar-btn-cancel"
            title="Cancel insert"
            aria-label="Cancel insert"
            @click="fr.hideR(anchorRow)"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </th>
    <th
        v-for="(col, index) in columns"
        :key="index"
        class="mdm-form-cell"
        :class="{
          'mdm-form-cell--select': fr.isMdmInlineSelectColumn(col, index),
          'mdm-form-cell--tel': columnsInfo[index]['fieldValidationType'] === 'phoneNumber',
          'mdm-form-cell--date': columnsInfo[index]['fieldValidationType'] === 'date',
          'sno-col': fr.mdmIsStickyAnchorDisplayName(col),
          'sticky-follow-col': cellLayout.flags[index],
          'mdm-sticky-block-edge': fr.isStickyBlockRightEdgeColumn(index),
        }"
        :style="cellLayout.styles[index]"
        style="background-color: rgb(231, 255, 231);font-size: 12px"
    >
      <!-- <label>{{ col }} -->
        <!-- <span v-if="columnsInfo[index]['fieldIsNullable']==='N'" class="text-danger">*</span> -->
      <!-- </label> -->

      <input
          v-if="columnsInfo[index]['inputFieldType']==='Enter Only' &&
          columnsInfo[index]['fieldValidationType'] !== 'email' &&
          columnsInfo[index]['fieldValidationType'] !== 'date' &&
          columnsInfo[index]['fieldValidationType'] !== 'number' &&
          columnsInfo[index]['fieldValidationType'] !== 'phoneNumber' &&
          columnsInfo[index]['fieldValidationType'] !== 'textarea'"
          :type="columnsInfo[index]['fieldValidationType']"
          @input="fr.updateInsertValue($event, rcolumns[index], columnsInfo[index]['requiredCase'])"
          @change="fr.handleValidateFunc(columnsInfo[index]['fieldValidationType'], rowEdit[rcolumns[index]])"
          :required="fr.fieldIsMandatory(columnsInfo[index])"
          :name="columnsInfo[index]['fieldValidationType']"
          :value="rowEdit[rcolumns[index]]"
          class="form-control"
          :class="{'mdm-required-input': isMandatory(index)}"
          :style="dynamicInputWidthStyle(rowEdit[rcolumns[index]], col, rcolumns[index])"
          :disabled="fr.mdmIsStickyAnchorDisplayName(col)"
      >

      <textarea
          v-if="columnsInfo[index]['fieldValidationType'] === 'textarea'"
          v-model="rowEdit[rcolumns[index]]"
          class="form-control auto-expand-textarea"
          :class="{'mdm-required-input': isMandatory(index)}"
          @input="fr.autoExpand"
      ></textarea>

      <ValidationProvider
          v-if="columnsInfo[index]['inputFieldType']=='Enter Only' && columnsInfo[index]['fieldValidationType'] === 'date' && fr.fieldIsMandatory(columnsInfo[index])"
          :vid="rcolumns[index]"
          :name="col"
          rules="required"
          v-slot="{ errors, validate }"
      >
        <div class="date-picker-container" :class="{'mdm-required-input': isMandatory(index)}">
          <date-picker
              v-model="rowEdit[rcolumns[index]]"
              value-type="DD/MM/YYYY"
              format="DD/MM/YYYY"
              type="date"
              placeholder="Select date"
              :clearable="false"
              @input="(v) => { fr.date(v, rcolumns[index]); validate(); }"
          ></date-picker>
          <span v-if="errors.length" class="help is-danger mdm-vee-error">
            {{ errors[0] }}
          </span>
        </div>
      </ValidationProvider>
      <div
          v-else-if="columnsInfo[index]['inputFieldType']=='Enter Only' && columnsInfo[index]['fieldValidationType'] === 'date'"
          class="date-picker-container"
          :class="{'mdm-required-input': isMandatory(index)}"
      >
        <date-picker
            v-model="rowEdit[rcolumns[index]]"
            value-type="DD/MM/YYYY"
            format="DD/MM/YYYY"
            type="date"
            placeholder="Select date"
            :clearable="false"
            @input="fr.date($event, rcolumns[index])"
        ></date-picker>
      </div>

      <validation-provider
          v-if="columnsInfo[index]['fieldValidationType']==='email'"
          :name="col"
          :vid="rcolumns[index]"
          :rules="fr.veeRulesEmail(columnsInfo[index])"
          v-slot="{ errors, validate }"
      >
        <input
            :type="columnsInfo[index]['fieldValidationType']"
            @change="fr.handleValidateFunc(columnsInfo[index]['fieldValidationType'], rowEdit[rcolumns[index]])"
            @input="validate"
            v-model="rowEdit[rcolumns[index]]"
            class="form-control"
            :class="{'mdm-required-input': isMandatory(index)}"
            :style="dynamicInputWidthStyle(rowEdit[rcolumns[index]], col, rcolumns[index])"
        >
        <span v-if="errors.length" class="help is-danger mdm-vee-error">
          {{ errors[0] }}
        </span>
      </validation-provider>

      <validation-provider
          v-if="columnsInfo[index]['fieldValidationType'] === 'number'"
          :name="col"
          :vid="rcolumns[index]"
          :rules="fr.veeRulesNumeric(columnsInfo[index])"
          v-slot="{ errors, validate }"
      >
        <input
            type="text"
            :value="fr.numberInputDisplay(rowEdit[rcolumns[index]])"
            @input="(e) => { fr.handleNumberInput(e, rcolumns[index], rowEdit); validate(e); }"
            class="form-control"
            :class="{'mdm-required-input': isMandatory(index)}"
            :style="dynamicInputWidthStyle(fr.numberInputDisplay(rowEdit[rcolumns[index]]), col, rcolumns[index])"
        >
        <span v-if="errors.length" class="help is-danger mdm-vee-error">
          {{ errors[0] }}
        </span>
      </validation-provider>

      <validation-provider
          v-if="columnsInfo[index]['fieldValidationType'] === 'phoneNumber'"
          :name="col"
          :vid="rcolumns[index]"
          :rules="fr.veeRulesPhone(columnsInfo[index])"
          v-slot="{ errors, validate }"
      >
        <input
            type="tel"
            @input="(e) => { fr.handleIndianPhoneNumberInput(e, rcolumns[index]); validate(e); }"
            v-model="rowEdit[rcolumns[index]]"
            class="form-control"
            :class="{'mdm-required-input': isMandatory(index)}"
            placeholder="Enter 10-digit phone number"
            maxlength="10"
            :style="dynamicInputWidthStyle(rowEdit[rcolumns[index]], col, rcolumns[index])"
        >
        <span v-if="errors.length" class="help is-danger mdm-vee-error">
          {{ errors[0] }}
        </span>
      </validation-provider>

      <span v-if="columnsInfo[index]['fieldValidationType']=='GSTINValidate'">
        <div>{{ fr.message }}</div>
        <div>{{ fr.name }}</div>
      </span>

      <div
          v-if="(col!=='Mfg. Name' && col!=='Brand Name') && fr.isMdmListboxField(columnsInfo[index])"
          class="mdm-inline-select"
          :class="{'mdm-required-input': isMandatory(index)}"
      >
        <v-select
            :append-to-body="true"
            :options="fr.getOptionsForRowSelect(rowEdit, rcolumns[index])"
            :value="rowEdit[rcolumns[index]]"
            @input="fr.onRowSelectInput(rowEdit, rcolumns[index], $event)"
        ></v-select>
      </div>
    </th>
  </tr>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import {ValidationProvider} from 'vee-validate'

export default {
  name: 'MdmFormReportInsertRow',
  components: {ValidationProvider, DatePicker},
  inject: ['mdmFormReport'],
  props: {
    rowEdit: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    rcolumns: {
      type: Array,
      required: true,
    },
    columnsInfo: {
      type: Array,
      required: true,
    },
    anchorRow: {
      type: Object,
      required: true,
    },
    cellLayout: {
      type: Object,
      required: true,
      validator(v) {
        return v && Array.isArray(v.flags) && Array.isArray(v.styles)
      },
    },
    mdmVeeInvalid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fr() {
      return this.mdmFormReport
    },
  },
  methods: {
    isMandatory(index) {
      return this.columnsInfo[index] && this.columnsInfo[index].fieldIsNullable === 'N'
    },
    dynamicInputWidthStyle(value, displayName, fieldKey) {
      const display = String(displayName == null ? '' : displayName).trim().toLowerCase()
      const key = String(fieldKey == null ? '' : fieldKey).trim().toLowerCase()
      if (display === 's.no' || display === 'syspk' || key === 'syspk') {
        return null
      }
      const len = String(value == null ? '' : value).length
      const chars = Math.min(Math.max(len + 2, 16), 48)
      return {
        width: `${chars}ch`,
        minWidth: '12rem',
        maxWidth: '100%',
      }
    },
  },
}
</script>

<style scoped>
.mdm-required-input.form-control {
  border-color: #f0b7bf !important;
  background: linear-gradient(180deg, #fffdfd 0%, #fff8f9 100%);
  box-shadow: inset 0 0 0 1px rgba(220, 53, 69, 0.08);
  transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
  border-radius: 0.25rem;
}

.mdm-required-input.form-control:hover {
  border-color: #e8a5af !important;
}

.mdm-required-input.form-control:focus {
  border-color: #d77a88 !important;
  box-shadow: 0 0 0 0.14rem rgba(215, 122, 136, 0.22), inset 0 0 0 1px rgba(215, 122, 136, 0.12) !important;
  background: #fff;
}

.mdm-required-input.form-control::placeholder {
  color: #b7848c;
  opacity: 0.9;
}

/* Vee-Validate field errors (Bulma class kept for backwards compatibility) */
.help.is-danger.mdm-vee-error,
.help.is-danger {
  color: #dc3545 !important;
  font-size: 0.8125rem;
  font-weight: 500;
  display: block;
  margin-top: 0.25rem;
  line-height: 1.3;
}

.mdm-required-input ::v-deep .mx-input,
.mdm-required-input ::v-deep .vs__dropdown-toggle {
  border-color: #f0b7bf !important;
  background: linear-gradient(180deg, #fffdfd 0%, #fff8f9 100%);
  box-shadow: inset 0 0 0 1px rgba(220, 53, 69, 0.08);
  transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
  border-radius: 0.25rem;
}

.mdm-required-input ::v-deep .mx-input:hover,
.mdm-required-input ::v-deep .vs__dropdown-toggle:hover {
  border-color: #e8a5af !important;
}

.mdm-required-input ::v-deep .mx-input:focus,
.mdm-required-input ::v-deep .vs__dropdown-toggle:focus,
.mdm-required-input ::v-deep .vs--open .vs__dropdown-toggle {
  border-color: #d77a88 !important;
  box-shadow: 0 0 0 0.14rem rgba(215, 122, 136, 0.22), inset 0 0 0 1px rgba(215, 122, 136, 0.12) !important;
  background: #fff;
}
</style>
